import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRole from '../reducers/role.reducer';

export const selectRoleState = createFeatureSelector<fromRole.State>(
  fromRole.roleFeatureKey
);

export const selectCurrentPage = createSelector(
  selectRoleState,
  (state: fromRole.State) => state?.currentPage
);

export const DeleteRoleShowErrorMessage = createSelector(
  selectRoleState,
  (state) => state.error_message
);
